<template>
  <div id="app" class="admin">
    <Menu/>
    <router-view class="admin-router"/>
  </div>
</template>

<script>
import Menu from './Menu.vue'

export default {
  components: {
    Menu
  }
}
</script>
